export default __webpack_public_path__ + "static/media/LogoBig.bad5135b.svg";